import React from "react";
import { AiOutlineClose } from "react-icons/ai";

interface ModalSelecaoDefeitosProps {
  open: boolean;
  onClose: () => void;
  filtro: string;
  setFiltro: (valor: string) => void;
  defeitos: any[];
  onSelect: (item: any) => void;
  titulo?: string;
}

const ModalSelecaoDefeitos: React.FC<ModalSelecaoDefeitosProps> = ({
  open,
  onClose,
  filtro,
  setFiltro,
  defeitos,
  onSelect,
  titulo = "Defeitos",
}) => {
  if (!open) return null;

  return (
    <div className="content-edit">
      <div className="info-content-edit" style={{ height: "65%", overflowY: "auto", position: "relative" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            marginBottom: 1,
          }}
        >
          <h1 style={{ margin: 0 }}>{titulo}</h1>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              marginLeft: 8,
              padding: 4,
              borderRadius: "50%",
              transition: "background 0.5s",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            aria-label="Fechar"
          >
            <AiOutlineClose size={24} color="#d83123" />
          </button>
        </div>

        <div
          className="divInput"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            position: "relative",
            width: "100%",
            margin: "10px auto",
          }}
        >
          <label style={{ marginBottom: 4, color: "#66afe9", fontWeight: "bold" }}>Filtrar</label>
          <input
            className="input-sign-in"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>

        {defeitos.map((item: any) => (
          <button
            key={item.id || item.idTipoDefeito}
            className="button-select-defeito styled-defeito-btn"
            onClick={() => onSelect(item)}
            type="button"
          >
            {item.tipoDefeito}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ModalSelecaoDefeitos;